// eslint-disable-next-line @typescript-eslint/no-var-requires
const packageJson = require('../package.json');
export const packageJsonDependencies = { ...packageJson.dependencies };
